export const appFeatureEnabled = (state, appFeatureName) => {
  return state['AppFeatures'].some(({ name }) => name === appFeatureName);
};
